import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react';

export const catalogReactTranslations = createTranslationResource({
  ref: catalogReactTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
